"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StormfallAbilityHandler = exports.StormfallActorAbilityFactory = exports.StormfallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const Windswept_1 = require("../../core/effects/core/Windswept");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_3 = require("../../core/event-handlers/core");
const DelayedDamage_1 = require("../../core/DelayedDamage");
const core_4 = require("../../core/actions/core");
class StormfallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Stormfall;
        this.__typeName = "Stormfall";
    }
}
exports.StormfallAbilityArgs = StormfallAbilityArgs;
let StormfallActorAbilityFactory = class StormfallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Stormfall", "AllEnemies", 0, 3);
    }
};
StormfallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Stormfall")
], StormfallActorAbilityFactory);
exports.StormfallActorAbilityFactory = StormfallActorAbilityFactory;
let StormfallAbilityHandler = class StormfallAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const lastInvocationCounter = container.readLocal(ability.invokerId, "Stormfall_InvocationCounter", 0);
        container.setLocal(ability.invokerId, "Stormfall_InvocationCounter", lastInvocationCounter + 1);
        container.applyProjectileAttacksWithDamage({
            sequence: sequence.pushSequence("sequential"),
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                creatorId: ability.invokerId,
                targetId,
                type: "PurpleTornado",
                path: "line",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Sonic", 50)
                ],
            })),
            // Stormfall dismisses all pets/summons/mirrors/etc.
            // These tornadoes apply "Windswept";
            // players may only have 1 stack of Windswept on them.
            // Players who have more than 1 stack of Windswept are thrown off the platform unable to be rezzed.
            //    The description for Windswept, "It's going to be a long fall."
            onHitOrMiss: (sequence, _attack, { targetId }) => {
                if (container.hasEffectOfType(targetId, EffectType_1.EffectType.Summoned)) {
                    container.applyEffect(sequence, ability.invokerId, targetId, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent);
                }
            },
            onHit: (sequence, _attack, _damages, { targetId }) => {
                if (container.hasEffectOfType(targetId, EffectType_1.EffectType.Windswept)) {
                    container.applyEffect(sequence, ability.invokerId, targetId, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent, true);
                    return;
                }
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new Windswept_1.WindsweptEffectArgs
                });
            },
        });
        // 75% - 0
        // 50% - 1
        // 25% - 2
        if (lastInvocationCounter >= 2) {
            container.applyBuff({
                sequence,
                creatorId: ability.invokerId,
                targetId: ability.invokerId,
                duration: Duration_1.Duration.Permanent,
                supernatural: true,
                // At 25%, the storms from stormfall cannot be dismissed (VFX should continue on the screen);
                // players will take 1% of their maximum health in damage per tick,
                // summons have a 50% chance of being instantly killed on use (including Mirror even when using Katja's Hourglass/Summon pet).
                // This cannot be avoided.
                // This ends when the players or Kaboom are dead,
                // whichever comes first.
                // When a player is killed by the storm effect, Kaboom will say, "KABOOM!"
                effect: new core_1.LinkedEffectsEffectArgs([
                    ...container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                        .flatMap(targetId => [
                        new core_1.LinkedVfxEffectArgs("Aura", sequence.pushArgs(new core_2.AuraVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest"), "PurpleTornado"))),
                        new core_1.LinkedEventHandlerEffectArgs("", "", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.CompanionAdded, Schedule_1.Schedule.Unlimited, "DestroyCompanion_OnAdded", {
                            attackerId: ability.invokerId,
                            percentChance: 50
                        })),
                        new core_1.LinkedEventHandlerEffectArgs("", "", false, container.registerEventHandlerScript(ability.invokerId, EventType_1.EventType.CompanionAdded, Schedule_1.Schedule.Unlimited, "ApplyAura_OnCompanionAdded", {
                            target: "companion",
                            attachment: "chest",
                            duration: Duration_1.Duration.Permanent,
                            type: "PurpleTornado"
                        })),
                    ]),
                    new core_1.LinkedEventHandlerEffectArgs("Intense Storm", "The storm is too strong!", false, container.registerEventHandler(ability.invokerId, EventType_1.EventType.Tick, Schedule_1.Schedule.Unlimited, new core_3.RecurringDamageEventHandlerArgs(ability.invokerId, Target_1.Target.AllEnemies, DelayedDamage_1.DelayedDamage.Focus("SonicPulse", "Sonic", 50)))),
                    new core_1.LinkedEventHandlerEffectArgs("", "", false, container.registerEventHandler(ability.invokerId, EventType_1.EventType.EnemyKilled, Schedule_1.Schedule.Unlimited, new core_3.DispatchActionEventHandlerArgs(new core_4.SpeakTextActionArgs("KABOOM!", "purple", "large"))))
                ], false)
            });
        }
    }
};
StormfallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Stormfall)
], StormfallAbilityHandler);
exports.StormfallAbilityHandler = StormfallAbilityHandler;
